// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b3b31e4d","455":"4c4e58d4","977":"99fddb85"}[chunkId] + ".chunk.js";
};